export const dishes = [
    '4315',
    '5252',
    '4317',
    '5253',
    '1645',
    '2971',
    '3478',
    '4102',
];

export const periods = [
    '2026-02-09',
    '2026-02-16',
    '2026-02-23',
    '2026-02-30',
    '2026-03-06',
];
